<template>
  <div style="width: 100% !important; min-width: 100% !important">
    <!-- <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          @click="bshop_mang_pop = true"
          v-on="on"
          class="btn-upload"
          style="width: 98% !important; min-width: 90% !important"
        >
          {{ $t("ROUTE.TITLES.NFC") }}
          <PackNfcIcon
            :size="32"
            :box="'#6366f1'"
            :bow-left="'#ec4899'"
            class="pa-2"
          />
        </v-btn>
      </template>
      <span>{{ $t("ROUTE.TITLES.NFC") }}</span>
    </v-tooltip> -->

    <custom-popup
      v-model="bshop_mang_pop"
      :cons="{ title: $t('ROUTE.TITLES.NFC') }"
      hide-confirm
      hide-overlay
      max-width="900"
      transition="dialog-bottom-transition"
    >
      <v-card class="px-5 py-4">
        <v-row no-gutters>
          <!-- Download Button -->
          <!-- <v-col cols="12">
            <v-alert border="left" color="success" colored-border elevation="2">
              <v-btn
                text
                color="success"
                @click="downloadProducts"
                class="text-break"
                :loading="downloadLoading"
              >
                <v-icon color="success" right>mdi-download</v-icon>
                {{ $t("products_export") }}
              </v-btn>
            </v-alert>
          </v-col> -->
          <!-- File Uploader -->
          <v-col class="mt-4" cols="12">
            <v-card
              id="uploader"
              ref="uploader"
              class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden"
              height="200"
              outlined
              @click="dragEvent"
              @dragleave="dragEvent"
              @dragover="dragEvent"
              @drop="dragEvent"
            >
              <v-icon size="68" style="opacity: 0.4"
                >mdi-cloud-upload-outline</v-icon
              >
              <v-card-title class="justify-center">{{
                $t("UPLOAD_EXCEL.UPLOAD_TITLE")
              }}</v-card-title>
              <v-card-text class="text-center pt-0 text-break">
                {{ $t("UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1") }}
                <v-btn class="mx-1" color="primary" min-width="75" small>
                  {{ $t("UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2") }}
                </v-btn>
                {{ $t("UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3") }}
              </v-card-text>
            </v-card>
          </v-col>
          <!-- Selected File Preview -->
          <v-col class="mt-3" cols="12">
            <v-card
              v-show="!!filesPreview && !!filesPreview.length"
              :loading="upLoading"
              class="mx-auto pa-2 rounded-lg"
              flat
              outlined
            >
              <div
                v-for="(item, i) in filesPreview"
                :key="i"
                class="pa-1 text-center"
              >
                <v-list-item>
                  <v-list-item-avatar
                    :color="item.color || 'success'"
                    class="white--text"
                    size="64"
                  >
                    <v-icon
                      >mdi-{{
                        !!item.color
                          ? !!item.status
                            ? "check"
                            : "close"
                          : "check"
                      }}</v-icon
                    >
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name" />
                  </v-list-item-content>
                  <v-list-item-action>
                    <div
                      v-if="!upLoading && (!item.status || !item.color)"
                      class="text-left fill-height"
                    >
                      <v-btn icon @click="removeFileFromUpload">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-list-item-action>
                </v-list-item>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-card-actions class="justify-end mt-4">
          <v-btn
            :disabled="!excelFile"
            :loading="upLoading"
            color="primary"
            depressed
            @click="sendFile"
          >
            {{ $t("GENERAL.SUBMIT") }}
          </v-btn>
          <v-btn color="error" text @click="bshop_mang_pop = false">
            {{ $t("GENERAL.CANCEL") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
import PackNfcIcon from "./PackNfcIcon.vue";
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie";

export default {
  name: "managment_nfc",
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    PackNfcIcon,
  },
  data() {
    return {
      downloadLoading: false,
      bshop_mang_pop: false,
      excelFile: null,
      filesPreview: [],
      upLoading: false,
    };
  },
  computed: {
    authToken() {
      return localStorage.getItem("id_token");
    },
    exportLang() {
      return getLanguageCookie() || this.$i18n.locale || "fa";
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();
      let uploader = this.$refs.uploader;

      if (
        e.type === "dragover" &&
        !uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.add("drag-over");
      else if (
        e.type === "dragleave" &&
        uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.remove("drag-over");
      else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");
        const files = e.target.files || e.dataTransfer.files;
        if (
          files[0] &&
          files[0].type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          this.excelFile = files[0];
          this.handleFileUpload(files[0]);
        } else {
          this.$toast.error(
            this.$t("UPLOAD_EXCEL.INVALID_FILE_TYPE") ||
              "لطفاً فقط فایل اکسل (.xlsx) آپلود کنید",
          );
        }
      } else if (e.type === "click") {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".xlsx";
        input.onchange = (event) => {
          const file = event.target.files[0];
          if (
            file &&
            file.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            this.excelFile = file;
            this.handleFileUpload(file);
          } else {
            this.$toast.error(
              this.$t("UPLOAD_EXCEL.INVALID_FILE_TYPE") ||
                "لطفاً فقط فایل اکسل (.xlsx) آپلود کنید",
            );
          }
        };
        input.click();
      }
    },
    handleFileUpload(file) {
      if (file) {
        this.filesPreview = [{ name: file.name }];
        this.$forceUpdate();
      }
    },
    removeFileFromUpload() {
      this.filesPreview = [];
      this.excelFile = null;
      this.$forceUpdate();
    },
    async sendFile() {
      if (!this.excelFile || !this.authToken || !this.id) {
        this.$toast.error(
          this.$t("GENERAL.ERROR") || "خطا: فایل، توکن یا شناسه QR معتبر نیست",
        );
        return;
      }

      this.upLoading = true;
      const data = new FormData();
      data.append("file", this.excelFile);

      try {
        const response = await this.$api.post("/admin/nfc/import", data);
        this.$toast.success(
          response.data?.message ||
            this.$t("GENERAL.SUCCESSFULLY_ADDED") ||
            "nfc ها با موفقیت آپلود شد",
        );
        this.bshop_mang_pop = false;
        this.removeFileFromUpload();
        this.$emit("fetch");
      } catch (error) {
        console.error("Failed to import products:", error);
        const errorMsg =
          error.response?.data?.message ||
          this.$t("GENERAL.ERROR") ||
          "خطا در آپلود محصولات";
        this.$toast.error(errorMsg);
      } finally {
        this.upLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.drag-over {
  background-color: #e0f7fa;
}
</style>
